import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import {catchError, debounceTime, distinctUntilChanged, map, tap, switchMap} from 'rxjs/operators';
import { environment } from './../../../../src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class EmissionCalcService {

  constructor(private http:HttpClient) { }
  
  API_KEY = environment.API_KEY;

  URL_1 = environment.Emission_calc_URL_1;

  URL_3 = 'https://staging.www.shipco.com/s3w/emission-calculator-calculate-scan';
  
 
  URL_2 = environment.Emission_calc_URL_2;

  //emission-calculator-seaports-scan
  //emission-calculator-airports-scan

  searchOriginAddress(term: string) {
    if (term === '') {
      return of([]);
    }
    return this.http
      .post(this.URL_1,  {
        API_KEY: this.API_KEY,
        term: term
     }).pipe(
        map(response => response)
      );
  }

  searchDestinationAddress(term: string) {
    if (term === '') {
      return of([]);
    }
    return this.http
      .post(this.URL_1,  {
        API_KEY: this.API_KEY,
        term: term
     }).pipe(
        map(response => response)
      );
  }

  searchDestinationPort(term: string,urlPort:string) {
    let tempUrl = ""
    if(urlPort ==='TST' || urlPort ==='SEA'){
      tempUrl = "emission-calculator-seaports-scan"
    }else{
      tempUrl = "emission-calculator-airports-scan";
    }


    if (term === '') {
      return of([]);
    }
    return this.http
      .post(this.URL_2 + tempUrl,  {
        API_KEY: this.API_KEY,
        term: term
     }).pipe(
        map(response => response)
      );
  }

  searchOriginPort(term: string,urlPort:string) {
    let tempUrl = ""
    if(urlPort ==='TST' || urlPort ==='SEA'){
      tempUrl = "emission-calculator-seaports-scan"
    }else{
      tempUrl = "emission-calculator-airports-scan";
    }
    if (term === '') {
      return of([]);
    }
    return this.http
      .post(this.URL_2 + tempUrl,  {
        API_KEY: this.API_KEY,
        term: term
     }).pipe(
        map(response => response)
      );
  }


 
  searchAllEmissionCalculator(obj:any){
    obj.API_KEY = this.API_KEY;
    return  this.http.post(this.URL_3,obj,{ responseType: 'text' });
  }

}
